import apiClient from "../../services/apiClient";

// 학생 포인트 · 기프티콘 상점(api/reward). 학원 계정으로 부른다.
const BASE = "/api/v1/reward";

// 이 학원·유형의 기본값 { reward_points, min_score } (학원 관리 > 포인트 에서 정한 값)
export const fetchDefaultRewardRuleAPI = async (assignmentType) => {
  const response = await apiClient.get(`${BASE}/teacher/default-points?type=${encodeURIComponent(assignmentType)}`, { withAuth: true });
  return response.data;
};
// { rule_list, work_photo_bonus(수학 계정만) }
export const fetchRewardRuleListAPI = async () => (await apiClient.get(`${BASE}/teacher/rules`, { withAuth: true })).data;
export const saveRewardRuleListAPI = async (ruleList, workPhotoBonus) =>
  (
    await apiClient.put(
      `${BASE}/teacher/rules`,
      { rule_list: ruleList, ...(workPhotoBonus !== undefined ? { work_photo_bonus: workPhotoBonus } : {}) },
      { withAuth: true }
    )
  ).data;

// 상점을 켠 학원인가(기프티쇼 키 + 활성화 체크). 출제 창마다 부르지 않게 한 번만 묻는다.
let rewardOpenPromise = null;
export const fetchRewardOpenAPI = () => {
  if (!rewardOpenPromise) {
    rewardOpenPromise = apiClient
      .get(`${BASE}/teacher/default-points?type=`, { withAuth: true })
      .then((response) => Boolean(response.data.is_open))
      .catch(() => {
        rewardOpenPromise = null;
        return false;
      });
  }
  return rewardOpenPromise;
};
export const forgetRewardOpen = () => {
  rewardOpenPromise = null;
};

export const fetchRewardAccountAPI = async () => (await apiClient.get(`${BASE}/teacher/account`, { withAuth: true })).data;
export const saveRewardAccountAPI = async (body) => (await apiClient.put(`${BASE}/teacher/account`, body, { withAuth: true })).data;
export const refreshRewardBalanceAPI = async () => (await apiClient.post(`${BASE}/teacher/balance`, {}, { withAuth: true })).data;
export const fetchAcademyRewardProductsAPI = async () => (await apiClient.get(`${BASE}/teacher/products`, { withAuth: true })).data;
export const selectAcademyRewardProductsAPI = async (productIdList, isSelected) =>
  (await apiClient.put(`${BASE}/teacher/products`, { product_id_list: productIdList, is_selected: isSelected }, { withAuth: true })).data;
export const fetchAcademyRewardOrdersAPI = async () => (await apiClient.get(`${BASE}/teacher/orders`, { withAuth: true })).data;

export const fetchAdminRewardProductsAPI = async (keyword = "") =>
  (await apiClient.get(`${BASE}/admin/products?q=${encodeURIComponent(keyword)}`, { withAuth: true })).data;
export const approveAdminRewardProductsAPI = async (productIdList, isApproved) =>
  (await apiClient.put(`${BASE}/admin/products`, { product_id_list: productIdList, is_hq_approved: isApproved }, { withAuth: true })).data;
